import { createLoadingReducer } from './utils';

export default createLoadingReducer('SIEDLE_SETTINGS');
